import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Dashboard',
  tabs: {
    [tabs.general]: 'Generale',
    [tabs.overview]: 'Panoramica',
    [tabs.orders]: 'Ordini per fonte',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Clienti',
    [tabs.order_conversion]: 'Conversione ordini',
    [tabs.mobile_app]: 'App mobile',
  },
  date_range: {
    this_month: 'Questo mese',
    last_month: 'Mese scorso',
    last_week: 'Settimana scorsa',
    this_week: 'Questa settimana',
    this_year: "Quest'anno",
    last_year: 'Anno scorso',
    today: 'Oggi',
    yesterday: 'Ieri',
    all: 'Tutti',
  },
  buttons: {
    view_key_info: 'Vedi info principali',
  },
  empty_franchise: {
    description: 'Questo brand non ha ancora un ristorante. Scegli un altro brand nel menu per vedere i suoi numeri.',
  },
};
